import { useLazySearchProductsQuery } from '@/core/api/graphql/forshawGraphqlApi.generated.ts'
import { useAccountBranchIdsParams } from '@/core/hooks/useAccountBranchIdsParams.ts'
import { replenishmentPlanActions } from '../slice/replenishmentPlan.slice.ts'
import { useDispatch } from 'react-redux'
import { mapProductOrderableToProduct } from '@/data/replenishmentPlan/mappers/mapProductOrderableToProduct.ts'
import { useCallback } from 'react'
import { useTrackReplenishmentPlanAnalyticsEvent } from '@/core/hooks/useTrackReplenishmentPlanAnalyticsEvent.ts'
import {
  DatagridActionsEvent,
  DatagridActionsType,
} from '@/core/analytics/events/replenishmentPlan/DatagridActionsEvent.ts'

const useSearchProducts = () => {
  const { branchId } = useAccountBranchIdsParams()

  const [search] = useLazySearchProductsQuery()

  const { trackReplenishmentPlanAnalyticsEvent } =
    useTrackReplenishmentPlanAnalyticsEvent()

  const dispatch = useDispatch()

  const searchProducts = useCallback(
    async (term: string) => {
      trackReplenishmentPlanAnalyticsEvent(
        new DatagridActionsEvent({
          type: DatagridActionsType.Search,
          value: term,
        }),
      )

      dispatch(replenishmentPlanActions.setIsSearchingProducts(true))

      try {
        const data = await search({
          branchId,
          term,
          includePlanUnavailable: true,
        }).unwrap()

        if (!data) {
          return
        }

        const products =
          data.productsOrderable?.map((product) => {
            return mapProductOrderableToProduct(product!)
          }) ?? []

        dispatch(replenishmentPlanActions.setProducts(products))
      } catch (e) {
        console.error(e)
      } finally {
        dispatch(replenishmentPlanActions.setIsSearchingProducts(false))
      }
    },
    [branchId, dispatch, search, trackReplenishmentPlanAnalyticsEvent],
  )

  return { searchProducts }
}

export { useSearchProducts }
